import { useRpc } from "../core/useRpc.js";
import { extendPromise } from "../../utils/promise.js";
import { useRpcCall } from "../core/useRpcCall.js";
export function useCategories({
  params,
  options,
  key: _key
} = {}, key) {
  const useRpcPromise = useRpc(
    "getCategoriesByPath",
    _key ?? key ?? "useCategories",
    params,
    options
  );
  const getCategoryById = useRpcCall("getCategoryById");
  const {
    data,
    error,
    status,
    fetch,
    fetching,
    refresh
  } = useRpcPromise;
  return extendPromise(useRpcPromise.then(() => ({})), {
    data,
    error,
    status,
    fetch,
    fetching,
    refresh,
    getCategoryById: (id, includeHidden) => getCategoryById({ id, includeHidden })
  });
}
